import React, { useMemo } from "react";
import { Row, Col, Modal, Form } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { AlertInfo } from "../../../../components/alert";
import LayoutJodit from "../../../../components/customizer/layout-jodit";

const ModalItemInformacionUtil = ({ showModal, setShowModal, formik, isEditing }) => {
  const [layoutJodit, setLayoutJodit] = React.useState("PC");

  const config = useMemo(
    () => ({
      readonly: false,
      height: 500,
      language: "es",
      disablePlugins: ["table"],
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      defaultActionOnPaste: "insert_clear_html",
      enableDragAndDropFileToEditor: true,
      uploader: {
        url: process.env.REACT_APP_BASE_URL + "/upload",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("jwt_token"),
        },
        data: null,
        filesVariableName: function () {
          return "files";
        },
        withCredentials: false,
        pathVariableName: "path",
        format: "json",
        method: "POST",
        prepareData: function (formData) {
          formData.append("id", 1);
        },
        isSuccess: function (resp) {
          return !resp.error;
        },
        getMessage: function (resp) {
          return resp.msgs.join("\n");
        },
        process: function (resp) {
          return resp;
        },
        defaultHandlerSuccess: function (resp) {
          var imagenesPermitidas = ["image/jpeg", "image/png"];
          for (var i = 0; i < resp.length; i++) {
            if (imagenesPermitidas.indexOf(resp[i].mime) !== -1) {
              var img1 = new Image();
              img1.src = resp[i]["url"];
              img1.alt = "imagen";
              img1.className = "img-fluid";
              this.s.insertImage(img1);
            } else if (resp[i].mime === "application/pdf") {
              const enlace = document.createElement("a");
              enlace.setAttribute("href", resp[i].url);
              const contenido = document.createTextNode(resp[i].name);
              enlace.appendChild(contenido);
              this.s.insertNode(enlace);
            } else {
              AlertInfo("Tipo de archivo no permitido");
            }
          }
        },
      },
    }),
    []
  );

  const handleCancel = () => {
    formik.resetForm();
    setShowModal(false);
  };

  return (
    <Modal dialogClassName="modal-90w" show={showModal} onHide={handleCancel}>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="mt-2">
            <Row>
              <Col>
                <label>{isEditing ? "Editar registro" : "Nuevo registro"}</label>
              </Col>
            </Row>
            <Col
              style={{
                marginTop: "15px",
                paddingTop: "15px",
                paddingBottom: "15px",
                overflow: "auto",
                maxHeight: "500px",
              }}
              className="border"
            >
              <Row>
                <Col>
                  <label>Título</label>
                  <input
                    name="titulo"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="form-control mb-3"
                    value={formik.values.titulo}
                  />
                  <div className="text-danger">{formik.errors?.titulo}</div>
                </Col>
              </Row>
              <Row>
                <Col className={`${layoutJodit === "MOBILE" && "col-6"}`}>
                  <Form.Group>
                    <label>Descripción</label>
                    <LayoutJodit
                      setLayoutJodit={setLayoutJodit}
                      layoutJodit={layoutJodit}
                    />
                    <JoditEditor
                      config={config}
                      value={formik.values.descripcion}
                      tabIndex={1}
                      onBlur={(value) =>
                        formik.setFieldValue("descripcion", value, false)
                      }
                    />
                    <div className="text-danger">{formik.errors?.descripcion}</div>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </div>

          <Row>
            <Col md={12}>
              <div className="mt-4">
                <div className="col-md-12" style={{ paddingBottom: "10px" }}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleCancel}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className="btn btn-success ml-2"
                      onClick={() => formik.handleSubmit()}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalItemInformacionUtil;
